import { Directive, ElementRef, HostListener, Injector, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { ManualEntryDto, UserServiceProxy, UserTrackingSettingCreateOrEditDto } from '@shared/service-proxies/service-proxies';
import { ProductivityCandle } from '../models/productivity-candle';
import { ProductivityBarService } from '../services/productivity-bar.service';
import { ProductivityBarComponent } from '../shared/productivity-bar/productivity-bar.component';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';

@Directive({
  standalone: false,
  selector: '[appCandleBase]'
})
export class CandleBaseDirective extends AppComponentBase implements OnInit, OnChanges {
  @Input() comingFrom:string;
  @Input() appCandleBase: number; // Get the index of the candle base
  @Input() productivityData: ProductivityCandle[]; // get the data
  @Input() manualTime: ManualEntryDto[]; // get the manual time
  @Input() parentElement: HTMLElement; // Get reference to container of the candle base
  @Input() productivityBarcomponent: ProductivityBarComponent; // day bar or week/month host (template passes `this`)
    manualTimeSlotInScope: ManualEntryDto;
    userTrackingSetting: UserTrackingSettingCreateOrEditDto;

    constructor(
        private productivityBarService: ProductivityBarService,
        injector: Injector,
        private _userServiceProxy: UserServiceProxy,
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
        super(injector);
    }

    /** Host passed from template (day: ProductivityBarComponent; week: ProductivityWeekComponent). */
    private get productivityBarHost(): ProductivityBarComponent {
        return this.productivityBarcomponent;
    }

  ngOnInit() {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
      if (!this.productivityData?.length) {
          return;
      }
      if (this.productivityData[this.appCandleBase]?.isManualTime && !this.productivityData[this.appCandleBase]?.isApproved) {
        this.renderer.addClass(this.elementRef.nativeElement, "active-fill-manual-time")
      }
      if (this.productivityData[this.appCandleBase]?.isManualTime && this.productivityData[this.appCandleBase]?.isApproved) {
        this.renderer.addClass(this.elementRef.nativeElement, "active-fill-private-time-approved")
      }

  }
    //
    // Mouse Enter Event
    //
    @HostListener('mouseenter') onMouseEnter() {  //   console.log("enter")   
        const host = this.productivityBarHost;
        if (host?.tenantId != null && host?.userId != null) {
            this.userWiseManualSettingMouseEnter(host.tenantId, host.userId);
        }
        if (this.productivityData[this.appCandleBase].privatePercent){
          let el = this.elementRef.nativeElement as HTMLElement;
          el.innerHTML = `<div class="position-absolute" style="width: 6rem;z-index: 501 !important;background-color: rgb(63, 63, 63);
          color: #fff; top: 85%;left: ${this.appCandleBase < 30 ? "-1px": "auto"}; right: ${this.appCandleBase > this.productivityData?.length - 30 ? "-1px": "auto"}">
                <div class="position-relative">
                  <div class="position-absolute" style="background: rgb(63, 63, 63);width: 100%;border-radius: 7px;text-align: center;">
                    <div class="font-size-xs">
                    <div>${this.l('PrivateTime')}</div>
                    </div>
                  </div>
                </div>
              </div>`;
          
        }
        if (this.productivityData[this.appCandleBase]?.isManualTime && !this.productivityData[this.appCandleBase]?.isApproved){
          let el = this.elementRef.nativeElement as HTMLElement;
          el.innerHTML = `<div class="position-absolute" style="width: 10rem;z-index: 501 !important;background-color: rgb(63, 63, 63);
          color: #fff; top: 85%;left: ${this.appCandleBase < 30 ? "-1px": "auto"}; right: ${this.appCandleBase > this.productivityData?.length - 30 ? "-1px": "auto"}">
                <div class="position-relative">
                  <div class="position-absolute" style="background: rgb(63, 63, 63);width: 100%;border-radius: 7px;text-align: center;">
                    <div class="font-size-xs">
                    <div>${this.l('PendingOfflineTime')}</div>
                    </div>
                  </div>
                </div>
              </div>`;
        }
    }
    //
    // Mouse Click Event
    //
    @HostListener('click') onClick() {
        const host = this.productivityBarHost;
        if (host?.tenantId != null && host?.userId != null) {
            this.userWiseManualSetting(host.tenantId, host.userId);
        }
    }
    //
    // Mouse Leave Event
    //  
    @HostListener('mouseleave') onMouseLeave() {//console.log("leaving");      
        const host = this.productivityBarHost;
        if (host?.tenantId != null && host?.userId != null) {
            this.userWiseManualSettingMouseLeave(host.tenantId, host.userId);
        }
        if (!this.productivityData[this.appCandleBase].privatePercent && !(this.productivityData[this.appCandleBase]?.isManualTime && !this.productivityData[this.appCandleBase]?.isApproved)) return;
        let el = this.elementRef.nativeElement as HTMLElement;
        el.innerHTML = "";
    }
    //
    // on Click Event Logical Process
    //
    private onClickFunctional() {
        const host = this.productivityBarHost as ProductivityBarComponent;
        if (typeof host?.loadProjects !== 'function') {
            return;
        }

        if (!this.productivityData[this.appCandleBase]?.isDataAvailable) {
            let [leftIndex, rightIndex] = this.findContiguosEmptyCandleBase(this.appCandleBase, this.productivityData);
            leftIndex += 1;
            rightIndex += 1;
            this.productivityBarcomponent.isSidebarOpen = true;
            this.productivityBarcomponent.loadProjects();
            this.productivityBarcomponent.resetSidebar();
            
            let startRange = this.productivityData[leftIndex - 1].date?.getHours() * 60 + this.productivityData[leftIndex - 1].date?.getMinutes();
            var endRange = this.productivityData[rightIndex - 1].date?.getHours() * 60 + this.productivityData[rightIndex - 1].date?.getMinutes() + 5;
            if (leftIndex == 1) {
                startRange = 0;
            }
            const currDate = new Date();
            const day = currDate.getDate();
            const month = currDate.getMonth() + 1;
            const year = currDate.getFullYear();
            const currDateStr = `${day}-${month}-${year}`;

            const prevDate = this.productivityData[leftIndex - 1]?.date;
            const prevday = prevDate?.getDate();
            const prevmonth = prevDate?.getMonth() + 1;
            const prevyear = prevDate?.getFullYear();
            const prevDateStr = `${prevday}-${prevmonth}-${prevyear}`;
          
            if (currDateStr == prevDateStr) {
                let currentTimeMins = currDate?.getHours() * 60 + currDate?.getMinutes() - 1;
                currentTimeMins -= currentTimeMins % 5;
                startRange = Math.min(currentTimeMins, startRange);

                var endTemp = currentTimeMins;
                if (this.productivityData[rightIndex - 1].date != undefined) {
                    endTemp = this.productivityData[rightIndex - 1].date?.getHours() * 60 + this.productivityData[rightIndex - 1].date?.getMinutes() + 5;
                }
                endRange = Math.min(currentTimeMins, endTemp)// rightIndex*60 ;//Math.min(currentTimeMins,this.productivityBarHost.sidebarSliderRangeValues[1]);

           }
          
        let t = this.setZeroTimeForLocalDate(this.productivityBarHost.selectedDate);
        let t2 = this.setZeroTimeForLocalDate(currDate);
            if( t.getTime() != t2.getTime()){
           if(rightIndex == this.productivityData.length){
            endRange = 1439;
            this.productivityBarHost.setCurrMins();
           }
            this.productivityBarHost.setCurrDay(true);
          }
          else{
            this.productivityBarHost.setCurrDay(false);
          }
            if(startRange==endRange){
              this.productivityBarcomponent.isSidebarOpen = false;
              return;
            }
            this.productivityBarHost.sidebarSliderRangeValues = [startRange,  endRange] 
            this.productivityBarHost.PRodSideBar();
        }
        if (this.productivityData[this.appCandleBase]?.isManualTime) {
            this.productivityBarcomponent.isSidebarOpen = true;
            this.productivityBarcomponent.loadProjects();
            let currentCandleMinutes = this.dateToMinutesIntheDay(this.productivityData[this.appCandleBase]?.date);
            this.manualTimeSlotInScope = this.manualTime.find(r => {
              let [startMinutes, endMinutes] = [this.dateToMinutesIntheDay(this.productivityBarService.getLocalJsDate(r.startTime)), this.dateToMinutesIntheDay(this.productivityBarService.getLocalJsDate(r.endTime))];
              return currentCandleMinutes >= startMinutes && currentCandleMinutes < endMinutes;
            });

            if(this.manualTimeSlotInScope) this.productivityBarHost.setDataForEdit(this.manualTimeSlotInScope);
            this.productivityBarHost.PRodSideBar();
           
        }
    }
    setZeroTimeForLocalDate(date: Date): Date {
      date.setHours(0, 0, 0, 0);
      return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }
    private addIdleTooltip(leftIndex: number, rightIndex: number){
      
      //check if between two tracked times
      if (leftIndex === 0 || (rightIndex + 1) === this.productivityData?.length) return;

      if(Math.floor((rightIndex - leftIndex + 1) * 5/60) == 0){
      let el = this.elementRef.nativeElement as HTMLElement;
          el.innerHTML = `<div id="tooltip" class="position-absolute" style="width: 10rem;z-index: 501 !important;background-color: rgb(63, 63, 63);
          color: #fff; top: 85%; left: ${this.appCandleBase < 30 ? "-1px": "auto"}; right: ${this.appCandleBase > this.productivityData?.length - 30 ? "-1px": "auto"}">
                <div class="position-relative">
                  <div class="position-absolute" style="background: rgb(63, 63, 63);width: 100%;border-radius: 7px;text-align: center;">
                    <div class="font-size-xs">
                    <div>${this.l('IdleTime')},   ${(rightIndex - leftIndex + 1) * 5 % 60}m</div>
                    </div>
                  </div>
                </div>
              </div>`;
      }else{
        let el = this.elementRef.nativeElement as HTMLElement;
        el.innerHTML = `<div id="tooltip" class="position-absolute" style="width: 10rem;z-index: 501 !important;background-color: rgb(63, 63, 63);
        color: #fff; top: 85%;left: ${this.appCandleBase < 30 ? "-1px": "auto"}; right: ${this.appCandleBase > this.productivityData?.length - 30 ? "-1px": "auto"}">
              <div class="position-relative">
                <div class="position-absolute" style="background: rgb(63, 63, 63);width: 100%;border-radius: 7px;text-align: center;">
                  <div class="font-size-xs">
                  <div>${this.l('IdleTime')},  ${Math.floor((rightIndex - leftIndex + 1) * 5/60)}h ${(rightIndex - leftIndex + 1) * 5 % 60}m</div>
                  </div>
                </div>
              </div>
            </div>`;
      }
              
    }

    //
    // on Mouse Enter Logical Process
    //
    private onMouseEnterFunctional() {
        if (!this.productivityData[this.appCandleBase]?.isDataAvailable) {
            let [leftIndex, rightIndex] = this.findContiguosEmptyCandleBase(this.appCandleBase, this.productivityData);
            this.addBorders(leftIndex, rightIndex, this.parentElement);
            this.addCursor(this.parentElement);
            this.addIdleTooltip(leftIndex, rightIndex);
        }
        else {
            this.removeIdleTooltip();
        }
    }
    //
    // on Mouse Leave Logical Process
    //
    private onMouseLeaveFunctional() {
        if (!this.productivityData[this.appCandleBase]?.isDataAvailable) {
            this.removeBorders(this.parentElement);
            this.removeIdleTooltip();
        }
    }
  removeIdleTooltip() {
      Array.from(document.querySelectorAll('#tooltip'))
          .forEach((val) => {
              val['style'].display = 'none';
          });
  }

  private findContiguosEmptyCandleBase(index: number, productivityData: ProductivityCandle[]): number[] {
    let leftIndex = index; let isLeftEndReached = false;
    let rightIndex = index; let isRightEndReached = false;

    while (!isLeftEndReached || !isRightEndReached) {
      leftIndex--;
      rightIndex++;
      if (leftIndex < 0 || productivityData[leftIndex]?.isDataAvailable) {
        isLeftEndReached = true;
        leftIndex++;
      }
      if (rightIndex === productivityData.length || productivityData[rightIndex]?.isDataAvailable) {
        isRightEndReached = true;
        rightIndex--;
      }
    }
    return [leftIndex, rightIndex];

  }

  private addBorders(leftIndex: number, rightIndex: number, containerElement: HTMLElement) {
    (containerElement).querySelectorAll('.time-segment').forEach((segment, i) => {
      if (i >= leftIndex && i <= rightIndex) {
        this.renderer.setStyle(segment, "border-top", "0.5px dashed #777");
        this.renderer.setStyle(segment, "border-bottom", "0.5px dashed #777");
      }
      if (i === leftIndex) {
        this.renderer.setStyle(segment, "border-left", "0.5px dashed #777");
      }
      if (i === rightIndex) {
        this.renderer.setStyle(segment, "border-right", "0.5px dashed #777");
      }
    })
    
  }

  private removeBorders(containerElement: HTMLElement) {
    containerElement.querySelectorAll('.time-segment').forEach((segment) => {
      this.renderer.removeStyle(segment, 'border');
    })
  }

  private addCursor(containerElement: HTMLElement) {
    containerElement.querySelectorAll('.time-segment').forEach((segment) => {
      this.renderer.addClass(segment, 'pointer');
    })
  }

  private removeCursor(containerElement: HTMLElement) {
    containerElement.querySelectorAll('.time-segment').forEach((segment) => {
      this.renderer.removeClass(segment, 'pointer');
    })
  }
  private dateToMinutesIntheDay(date: Date): number {
    return date.getHours() * 60 + date.getMinutes();
  }
    //
    // Get Setting For Show Manual Add User Wise Setting For Click event
    //
    private userWiseManualSetting(tenantId: number, userId: number) {    

      if(this.comingFrom=="RealTime"){
        return;
      }
      if (!AppConsts.getUserTrackingSettingForEditInstance) {
        this._userServiceProxy.getUserTrackingSettingForEdit(tenantId, userId).subscribe(res => {         
            this.userTrackingSetting = res; AppConsts.getUserTrackingSettingForEditInstance = res;
            this.userWiseManualSettingAfter();
        });
      } else { this.userTrackingSetting = AppConsts.getUserTrackingSettingForEditInstance;
        this.userWiseManualSettingAfter(); }
    }
    userWiseManualSettingAfter() {
      if (this.userTrackingSetting?.offlineTime == 1) { this.onClickFunctional(); }
      else if (this.userTrackingSetting?.offlineTime == 2) { return; }
      else if (this.userTrackingSetting?.offlineTime == 3) { this.onClickFunctional(); return; }
      else { this.onClickFunctional(); return; }
    }
    //
    // Get Setting for Mouse Enter Click Event UserWise
    //
    private userWiseManualSettingMouseEnter(tenantId: number, userId: number) {
      if (!AppConsts.getUserTrackingSettingForEditInstance) {
        this._userServiceProxy.getUserTrackingSettingForEdit(tenantId, userId).subscribe(res => {
            this.userTrackingSetting = res; AppConsts.getUserTrackingSettingForEditInstance= res;
            this.userWiseManualSettingMouseEnterAfter();
        });
      } else { this.userTrackingSetting = AppConsts.getUserTrackingSettingForEditInstance;
        this.userWiseManualSettingMouseEnterAfter(); }
    }
    userWiseManualSettingMouseEnterAfter() {
      if (this.userTrackingSetting?.offlineTime == 1) { this.onMouseEnterFunctional(); }
      else if (this.userTrackingSetting?.offlineTime == 2) { return; }
      else if (this.userTrackingSetting?.offlineTime == 3) { this.onMouseEnterFunctional(); return; }
      else { this.onMouseEnterFunctional(); return; }
    }
    //
    // Get Setting for Mouse Leave Click Event UserWise
    //
    private userWiseManualSettingMouseLeave(tenantId: number, userId: number) {
      if (!AppConsts.getUserTrackingSettingForEditInstance) {
        this._userServiceProxy.getUserTrackingSettingForEdit(tenantId, userId).subscribe(res => {
            this.userTrackingSetting = res; AppConsts.getUserTrackingSettingForEditInstance = res;
            this.userWiseManualSettingMouseLeaveAfter();
        });
      } else { this.userTrackingSetting = AppConsts.getUserTrackingSettingForEditInstance;
          this.userWiseManualSettingMouseLeaveAfter();
      }
    }
    userWiseManualSettingMouseLeaveAfter() {
      if (this.userTrackingSetting?.offlineTime == 1) { this.onMouseLeaveFunctional(); }
      else if (this.userTrackingSetting?.offlineTime == 2) { return; }
      else if (this.userTrackingSetting?.offlineTime == 3) { this.onMouseLeaveFunctional(); return; }
      else { this.onMouseLeaveFunctional(); return; }
    }
}
